module.exports = __webpack_public_path__ + "img/25.07bb2c94.jpg";